import AddLineDropdownTemplate from '../templates/add_line_dropdown_template'
import AddLineDataFormatter from '../utils/add_line_data_formatter'

export default {
  initializeFilterState() {
    this.initialCategoriesState = null
    this.initialExchangesState = null
    this.initialAdTypesState = null
  },

  toggleCategoryDropdown(event) {
    event.preventDefault()
    const menu = this.categoryDropdownMenuTarget
    const isVisible = menu.style.display === 'block' ||
                     (menu.style.display === '' && menu.offsetHeight > 0)

    if (isVisible) {
      menu.style.display = 'none'
      this.applyFilterIfCategoriesChanged()
    } else {
      menu.style.display = 'block'
      this.initialCategoriesState = [...this.selectedCategoriesValue]
      if (this.hasCategorySearchInputTarget) {
        this.categorySearchInputTarget.focus()
      }
    }
  },

  onCategoryCheckboxChange(event) {
    const categoryId = event.target.value
    const isChecked = event.target.checked
    const numericId = isNaN(categoryId) ? categoryId : parseInt(categoryId)

    if (isChecked) {
      if (!this.selectedCategoriesValue.some(id => String(id) === String(numericId))) {
        this.selectedCategoriesValue = [...this.selectedCategoriesValue, numericId]
      }
    } else {
      this.selectedCategoriesValue = this.selectedCategoriesValue.filter(id => String(id) !== String(numericId))
    }

    this.updateCategoryButtonText()
    this.updateCategoryClearLink()
  },

  onCategorySearch(event) {
    const searchTerm = event.target.value.toLowerCase()

    if (searchTerm === '') {
      this.filteredCategoriesValue = this.availableCategoriesValue
    } else {
      this.filteredCategoriesValue = this.availableCategoriesValue.filter(category =>
        category.label.toLowerCase().includes(searchTerm)
      )
    }

    this.updateCategoryDropdown()
  },

  selectAllCategories(event) {
    event.preventDefault()
    this.selectedCategoriesValue = this.filteredCategoriesValue.map(cat => cat.id)
    this.updateCategoryDropdown()
  },

  clearCategories(event) {
    event.preventDefault()
    this.selectedCategoriesValue = []
    this.updateCategoryDropdown()
  },

  applyFilterIfCategoriesChanged() {
    if (this.initialCategoriesState === null) {
      this.onFilterChange()
      return
    }

    const currentCategories = [...this.selectedCategoriesValue].map(String).sort()
    const initialCategories = [...this.initialCategoriesState].map(String).sort()
    const currentSet = new Set(currentCategories)
    const initialSet = new Set(initialCategories)
    const hasChanged = currentSet.size !== initialSet.size ||
                      [...currentSet].some(cat => !initialSet.has(cat))

    if (hasChanged) {
      this.onFilterChange()
    }

    this.initialCategoriesState = null
  },

  toggleExchangeDropdown(event) {
    event.preventDefault()
    const menu = this.exchangeDropdownMenuTarget
    const isVisible = menu.style.display === 'block' ||
                     (menu.style.display === '' && menu.offsetHeight > 0)

    if (isVisible) {
      menu.style.display = 'none'
      this.applyFilterIfExchangesChanged()
    } else {
      menu.style.display = 'block'
      this.initialExchangesState = [...this.selectedExchangesValue]

      if (this.hasExchangeSearchInputTarget) {
        this.exchangeSearchInputTarget.focus()
      }
    }
  },

  onExchangeCheckboxChange(event) {
    const exchangeId = event.target.value
    const isChecked = event.target.checked
    const numericId = isNaN(exchangeId) ? exchangeId : parseInt(exchangeId)

    if (isChecked) {
      if (!this.selectedExchangesValue.some(id => String(id) === String(numericId))) {
        this.selectedExchangesValue = [...this.selectedExchangesValue, numericId]
      }
    } else {
      this.selectedExchangesValue = this.selectedExchangesValue.filter(id => String(id) !== String(numericId))
    }

    this.updateExchangeButtonText()
    this.updateExchangeClearLink()
  },

  onExchangeSearch(event) {
    const searchTerm = event.target.value.toLowerCase()

    if (searchTerm === '') {
      this.filteredExchangesValue = this.availableExchangesValue
    } else {
      this.filteredExchangesValue = this.availableExchangesValue.filter(exchange =>
        exchange.label.toLowerCase().includes(searchTerm)
      )
    }

    this.updateExchangeDropdown()
  },

  selectAllExchanges(event) {
    event.preventDefault()
    this.selectedExchangesValue = this.filteredExchangesValue.map(ex => ex.id)
    this.updateExchangeDropdown()
  },

  clearExchanges(event) {
    event.preventDefault()
    this.selectedExchangesValue = []
    this.updateExchangeDropdown()
  },

  applyFilterIfExchangesChanged() {
    if (this.initialExchangesState === null) {
      this.onFilterChange()
      return
    }

    const currentExchanges = [...this.selectedExchangesValue].map(String).sort()
    const initialExchanges = [...this.initialExchangesState].map(String).sort()
    const currentSet = new Set(currentExchanges)
    const initialSet = new Set(initialExchanges)
    const hasChanged = currentSet.size !== initialSet.size ||
                      [...currentSet].some(ex => !initialSet.has(ex))

    if (hasChanged) {
      this.onFilterChange()
    }

    this.initialExchangesState = null
  },

  toggleAdTypeDropdown(event) {
    event.preventDefault()
    const menu = this.adTypeDropdownMenuTarget
    const isVisible = menu.style.display === 'block' ||
                     (menu.style.display === '' && menu.offsetHeight > 0)

    if (isVisible) {
      menu.style.display = 'none'
      this.applyFilterIfAdTypesChanged()
    } else {
      menu.style.display = 'block'
      this.initialAdTypesState = [...this.selectedAdTypesValue]

      if (this.hasAdTypeSearchInputTarget) {
        this.adTypeSearchInputTarget.focus()
      }
    }
  },

  toggleImpTypeDropdown(event) {
    event.preventDefault()
    const menu = this.impTypeDropdownMenuTarget
    const isVisible = menu.style.display === 'block' ||
                     (menu.style.display === '' && menu.offsetHeight > 0)

    if (isVisible) {
      menu.style.display = 'none'
      this.applyFilterIfImpTypesChanged()
    } else {
      menu.style.display = 'block'
      this.initialImpTypesState = [...this.selectedImpTypesValue]

      if (this.hasImpTypeSearchInputTarget) {
        this.impTypesSearchInputTarget.focus()
      }
    }
  },

  onImpTypeCheckboxChange(event) {
    const impTypesId = event.target.value
    const isChecked = event.target.checked

    if (isChecked) {
      if (!this.selectedImpTypesValue.includes(impTypesId)) {
        this.selectedImpTypesValue = [...this.selectedImpTypesValue, impTypesId]
      }
    } else {
      this.selectedImpTypesValue = this.selectedImpTypesValue.filter(id => id !== impTypesId)
    }

    this.updateImpTypeButtonText()
    this.updateImpTypeClearLink()
  },

  onImpTypeSearch(event) {
    const searchTerm = event.target.value.toLowerCase()

    if (searchTerm === '') {
      this.filteredImpTypesValue = this.availableImpTypesValue
    } else {
      this.filteredImpTypesValue = this.availableImpTypesValue.filter(impTypes =>
        impTypes.label.toLowerCase().includes(searchTerm)
      )
    }

    this.updateImpTypeDropdown()
  },

  selectAllImpTypes(event) {
    event.preventDefault()
    this.selectedImpTypesValue = this.filteredImpTypesValue.map(ad => ad.id)
    this.updateImpTypeDropdown()
  },

  clearImpTypes(event) {
    event.preventDefault()
    this.selectedImpTypesValue = []
    this.updateImpTypeDropdown()
  },

  applyFilterIfImpTypesChanged() {
    if (this.initialImpTypesState === null) {
      this.onFilterChange()
      return
    }

    const currentImpTypes = [...this.selectedImpTypesValue].map(String).sort()
    const initialImpTypes = [...this.initialImpTypesState].map(String).sort()
    const currentSet = new Set(currentImpTypes)
    const initialSet = new Set(initialImpTypes)
    const hasChanged = currentSet.size !== initialSet.size ||
                      [...currentSet].some(ad => !initialSet.has(ad))

    if (hasChanged) {
      this.onFilterChange()
    }

    this.initialImpTypesState = null
  },

  onAdTypeCheckboxChange(event) {
    const adTypeId = event.target.value
    const isChecked = event.target.checked

    const adType = this.allAdTypesValue.find(type => type.id === adTypeId)
    if (isChecked && adType && adType.available === false) {
      event.preventDefault()
      event.target.checked = false
      return
    }

    if (isChecked) {
      if (!this.selectedAdTypesValue.includes(adTypeId)) {
        this.selectedAdTypesValue = [...this.selectedAdTypesValue, adTypeId]
      }
    } else {
      this.selectedAdTypesValue = this.selectedAdTypesValue.filter(id => id !== adTypeId)
    }

    this.updateAdTypeButtonText()
    this.updateAdTypeClearLink()
  },

  onAdTypeSearch(event) {
    const searchTerm = event.target.value.toLowerCase()

    if (searchTerm === '') {
      this.filteredAdTypesValue = this.availableAdTypesValue
    } else {
      this.filteredAdTypesValue = this.availableAdTypesValue.filter(adType =>
        adType.label.toLowerCase().includes(searchTerm)
      )
    }

    this.updateAdTypeDropdown()
  },

  selectAllAdTypes(event) {
    event.preventDefault()
    this.selectedAdTypesValue = this.filteredAdTypesValue
      .filter(ad => ad.available !== false)
      .map(ad => ad.id)
    this.updateAdTypeDropdown()
  },

  clearAdTypes(event) {
    event.preventDefault()
    this.selectedAdTypesValue = []
    this.updateAdTypeDropdown()
  },

  applyFilterIfAdTypesChanged() {
    if (this.initialAdTypesState === null) {
      this.onFilterChange()
      return
    }

    const currentAdTypes = [...this.selectedAdTypesValue].map(String).sort()
    const initialAdTypes = [...this.initialAdTypesState].map(String).sort()
    const currentSet = new Set(currentAdTypes)
    const initialSet = new Set(initialAdTypes)
    const hasChanged = currentSet.size !== initialSet.size ||
                      [...currentSet].some(ad => !initialSet.has(ad))

    if (hasChanged) {
      this.onFilterChange()
    }

    this.initialAdTypesState = null
  },

  buildFilterParam() {
    const filters = {}

    if (this.hasSearchInputTarget && this.searchInputTarget.value) {
      const parsed = AddLineDataFormatter.parseSearchInput(this.searchInputTarget.value)
      if (parsed) {
        filters[parsed.field] = parsed.value
      }
    }

    if (this.selectedCategoriesValue.length > 0) {
      const enumStrings = this.selectedCategoriesValue.map(numericId => {
        if (window.ssbAppCategoryEnumToId) {
          const enumString = Object.keys(window.ssbAppCategoryEnumToId).find(
            key => window.ssbAppCategoryEnumToId[key] == numericId
          )
          return enumString || numericId
        }
        return numericId
      })
      filters['category-id'] = enumStrings.join(',')
    }

    if (this.selectedExchangesValue.length > 0) {
      const exchangeIds = this.selectedExchangesValue.map(id => parseInt(id)).filter(id => !isNaN(id))
      filters['exchange-id'] = exchangeIds.join(',')
    }

    if (this.selectedAdTypesValue.length > 0) {
      filters['ad-type'] = this.selectedAdTypesValue.join(',')
    }

    if (this.selectedImpTypesValue.length > 0) {
      filters['imp-type'] = this.selectedImpTypesValue.join(',')
    }

    if (this.hasStatusSelectTarget && this.statusSelectTarget.value) {
      filters.status = this.statusSelectTarget.value
    }

    return filters
  },

  handleDocumentClick(event) {
    this._handleDropdownDocumentClick(event, 'category')
    this._handleDropdownDocumentClick(event, 'exchange')
    this._handleDropdownDocumentClick(event, 'adType')
    this._handleDropdownDocumentClick(event, 'impType')
  },

  _handleDropdownDocumentClick(event, type) {
    const dropdownTarget = `${type}DropdownTarget`
    const menuTarget = `${type}DropdownMenuTarget`
    const hasDropdown = `has${type.charAt(0).toUpperCase() + type.slice(1)}DropdownTarget`
    const hasMenu = `has${type.charAt(0).toUpperCase() + type.slice(1)}DropdownMenuTarget`
    const applyFilterMethods = {
      'category': 'applyFilterIfCategoriesChanged',
      'exchange': 'applyFilterIfExchangesChanged',
      'adType': 'applyFilterIfAdTypesChanged',
      'impType': 'applyFilterIfImpTypesChanged'
    }
    const applyFilterMethod = applyFilterMethods[type]

    if (this[hasDropdown] && this[hasMenu] && applyFilterMethod) {
      const dropdown = this[dropdownTarget]
      const menu = this[menuTarget]
      const isVisible = menu.style.display === 'block' ||
                       (menu.style.display === '' && menu.offsetHeight > 0)

      if (!dropdown.contains(event.target) && isVisible) {
        menu.style.display = 'none'
        if (typeof this[applyFilterMethod] === 'function') {
          this[applyFilterMethod]()
        }
      }
    }
  },

  updateCategoryDropdown() {
    if (!this.hasCategoryListTarget) return

    const html = AddLineDropdownTemplate.renderCategoryDropdown(
      this.filteredCategoriesValue, 
      this.selectedCategoriesValue
    )
    this.categoryListTarget.innerHTML = html
    this.updateCategoryButtonText()
    this.updateCategoryClearLink()
  },

  updateExchangeDropdown() {
    if (!this.hasExchangeListTarget) return

    const html = AddLineDropdownTemplate.renderExchangeDropdown(
      this.filteredExchangesValue,
      this.selectedExchangesValue
    )
    this.exchangeListTarget.innerHTML = html
    this.updateExchangeButtonText()
    this.updateExchangeClearLink()
  },

  updateAdTypeDropdown() {
    if (!this.hasAdTypeListTarget) return

    const html = AddLineDropdownTemplate.renderAdTypeDropdown(
      this.filteredAdTypesValue,
      this.selectedAdTypesValue
    )
    this.adTypeListTarget.innerHTML = html
    this.updateAdTypeButtonText()
    this.updateAdTypeClearLink()
  },

  updateImpTypeDropdown() {
    if (!this.hasImpTypeListTarget) return

    const html = AddLineDropdownTemplate.renderImpTypeDropdown(
      this.filteredImpTypesValue,
      this.selectedImpTypesValue
    )
    this.impTypeListTarget.innerHTML = html
    this.updateImpTypeButtonText()
    this.updateImpTypeClearLink()
  },

  updateCategoryButtonText() {
    if (!this.hasCategoryButtonTextTarget) return

    const text = AddLineDropdownTemplate.getDropdownButtonText(
      this.selectedCategoriesValue,
      this.availableCategoriesValue,
      'All Categories'
    )
    this.categoryButtonTextTarget.textContent = text
  },

  updateExchangeButtonText() {
    if (!this.hasExchangeButtonTextTarget) return

    const text = AddLineDropdownTemplate.getDropdownButtonText(
      this.selectedExchangesValue,
      this.availableExchangesValue,
      'All Exchanges'
    )
    this.exchangeButtonTextTarget.textContent = text
  },

  updateAdTypeButtonText() {
    if (!this.hasAdTypeButtonTextTarget) return

    const text = AddLineDropdownTemplate.getDropdownButtonText(
      this.selectedAdTypesValue,
      this.availableAdTypesValue,
      'All Ad Types'
    )
    this.adTypeButtonTextTarget.textContent = text
  },

  updateImpTypeButtonText() {
    if (!this.hasImpTypeButtonTextTarget) return

    const text = AddLineDropdownTemplate.getDropdownButtonText(
      this.selectedImpTypesValue,
      this.availableImpTypesValue,
      'All Imp Types'
    )
    this.impTypeButtonTextTarget.textContent = text
  },

  updateCategoryCounts(newCounts) {
    const existingEnumStrings = new Set()
    this.allCategoriesValue.forEach(category => {
      if (typeof category.id === 'string') {
        existingEnumStrings.add(category.id)
      } else {
        const enumString = Object.keys(window.ssbAppCategoryEnumToId || {}).find(
          key => window.ssbAppCategoryEnumToId[key] == category.id
        )
        if (enumString) existingEnumStrings.add(enumString)
      }
    })

    this.allCategoriesValue = this.allCategoriesValue.map(category => {
      let enumString = null

      if (typeof category.id === 'string') {
        enumString = category.id
      } else {
        enumString = Object.keys(window.ssbAppCategoryEnumToId || {}).find(
          key => window.ssbAppCategoryEnumToId[key] == category.id
        )
      }

      const count = newCounts[enumString] || 0

      return { ...category, count }
    })

    this.availableCategoriesValue = this.allCategoriesValue
    this.filteredCategoriesValue = this.allCategoriesValue.filter(category =>
      category.id !== 'APP_CATEGORY_UNKNOWN'
    )

    this.updateCategoryDropdown()
  },

  updateExchangeCounts(newCounts) {
    const exchangeIds = Object.keys(newCounts)
    this.allExchangesValue = exchangeIds.map(id => ({
      id: id,
      label: this.getExchangeName(id),
      count: newCounts[id] || 0
    })).sort((a, b) => {
      const labelA = a.label || ''
      const labelB = b.label || ''
      return labelA.localeCompare(labelB)
    })

    this.exchanges = this.allExchangesValue
    this.availableExchangesValue = this.allExchangesValue
    this.filteredExchangesValue = this.allExchangesValue
    this.updateExchangeSelect()
    this.updateExchangeDropdown()
  },

  updateAdTypeCounts(newCounts) {
    this.allAdTypesValue = this.allAdTypesValue.map(adType => {
      const count = newCounts[adType.id] || 0
      return { ...adType, count }
    })

    this.availableAdTypesValue = this.allAdTypesValue
    this.filteredAdTypesValue = this.allAdTypesValue
    this.updateAdTypeDropdown()
  },

  updateImpTypeCounts(newCounts) {
    this.allImpTypesValue = this.allImpTypesValue.map(impType => {
      const count = newCounts[impType.id] || 0
      return { ...impType, count }
    })

    this.availableImpTypesValue = this.allImpTypesValue
    this.filteredImpTypesValue = this.allImpTypesValue
    this.updateImpTypeDropdown()
  },

  updateAvailableAdTypes(availableAdTypes) {
    this.creativeAdTypesValue = availableAdTypes

    this.allAdTypesValue = this.allAdTypesValue.map(adType => ({
      ...adType,
      available: this.creativeAdTypesValue.includes(adType.id)
    }))

    this.availableAdTypesValue = this.allAdTypesValue
    this.filteredAdTypesValue = this.allAdTypesValue
    this.updateAdTypeDropdown()
  },

  updateFilterSelects() {
    const currentCategoryValue = this.hasCategorySelectTarget ? this.categorySelectTarget.value : ''
    const currentExchangeValue = this.hasExchangeSelectTarget ? this.exchangeSelectTarget.value : ''
    const currentStatusValue = this.hasStatusSelectTarget ? this.statusSelectTarget.value : ''

    if (this.hasCategorySelectTarget) {
      this.categorySelectTarget.innerHTML = AddLineDataFormatter.buildSelectOptions([
        { id: '', label: 'All Categories' },
        ...this.categories
      ])
      this.categorySelectTarget.value = currentCategoryValue
    }

    if (this.hasExchangeSelectTarget) {
      this.exchangeSelectTarget.innerHTML = AddLineDataFormatter.buildSelectOptions([
        { id: '', label: 'All Exchanges' },
        ...this.exchanges
      ])
      this.exchangeSelectTarget.value = currentExchangeValue
    }

    if (this.hasStatusSelectTarget) {
      this.statusSelectTarget.innerHTML = AddLineDataFormatter.buildSelectOptions(this.statuses, 'value', 'label')
      this.statusSelectTarget.value = currentStatusValue
    }

    this.updateExchangeDropdown()
    this.updateAdTypeDropdown()
    this.updateImpTypeDropdown()
  },

  updateExchangeSelect() {
    if (!this.hasExchangeSelectTarget) return

    const currentValue = this.exchangeSelectTarget.value
    this.exchangeSelectTarget.innerHTML = AddLineDataFormatter.buildSelectOptions([
      { id: '', label: 'All Exchanges' },
      ...this.exchanges
    ])
    this.exchangeSelectTarget.value = currentValue
  },

  updateCategoryClearLink() {
    if (this.hasClearCategoriesLinkTarget && this.hasCategorySeparatorTarget) {
      if (this.selectedCategoriesValue.length > 0) {
        this.clearCategoriesLinkTarget.classList.remove('hidden')
        this.categorySeparatorTarget.classList.remove('hidden')
      } else {
        this.clearCategoriesLinkTarget.classList.add('hidden')
        this.categorySeparatorTarget.classList.add('hidden')
      }
    }
  },

  updateExchangeClearLink() {
    if (this.hasClearExchangesLinkTarget && this.hasExchangeSeparatorTarget) {
      if (this.selectedExchangesValue.length > 0) {
        this.clearExchangesLinkTarget.classList.remove('hidden')
        this.exchangeSeparatorTarget.classList.remove('hidden')
      } else {
        this.clearExchangesLinkTarget.classList.add('hidden')
        this.exchangeSeparatorTarget.classList.add('hidden')
      }
    }
  },

  updateAdTypeClearLink() {
    if (this.hasClearAdTypesLinkTarget && this.hasAdTypeSeparatorTarget) {
      if (this.selectedAdTypesValue.length > 0) {
        this.clearAdTypesLinkTarget.classList.remove('hidden')
        this.adTypeSeparatorTarget.classList.remove('hidden')
      } else {
        this.clearAdTypesLinkTarget.classList.add('hidden')
        this.adTypeSeparatorTarget.classList.add('hidden')
      }
    }
  },

  updateImpTypeClearLink() {
    if (this.hasClearImpTypesLinkTarget && this.hasImpTypeSeparatorTarget) {
      if (this.selectedImpTypesValue.length > 0) {
        this.clearImpTypesLinkTarget.classList.remove('hidden')
        this.impTypeSeparatorTarget.classList.remove('hidden')
      } else {
        this.clearImpTypesLinkTarget.classList.add('hidden')
        this.impTypeSeparatorTarget.classList.add('hidden')
      }
    }
  },

  updateFiltersLists(lineSuggestions) {
    if (this.allCategoriesValue.length === 0 && this.selectedCategoriesValue.length === 0) {
      const categoryCounts = {}
      const categoryIds = []

      lineSuggestions.forEach(line => {
        const categoryId = line.categoryId
        if (categoryId) {
          if (!categoryCounts[categoryId]) {
            categoryCounts[categoryId] = 0
            categoryIds.push(categoryId)
          }
          categoryCounts[categoryId]++
        }
      })

      const categories = categoryIds.map(id => {
        let numericId = id
        if (window.ssbAppCategoryEnumToId && window.ssbAppCategoryEnumToId[id]) {
          numericId = window.ssbAppCategoryEnumToId[id]
        }

        return {
          id: numericId,
          label: this.getCategoryDisplayName(id),
          count: categoryCounts[id]
        }
      })

      categories.sort((a, b) => {
        const labelA = a.label || ''
        const labelB = b.label || ''
        return labelA.localeCompare(labelB)
      })
      this.allCategoriesValue = categories
    }

    this.availableCategoriesValue = this.allCategoriesValue
    this.filteredCategoriesValue = this.allCategoriesValue

    if (this.allAdTypesValue.length === 0) {
      const adTypes = [
        { id: 'banner', label: 'Banner', count: 0 },
        { id: 'video', label: 'Video', count: 0 },
        { id: 'native', label: 'Native', count: 0 },
        { id: 'rvideo', label: 'Rewarded Video', count: 0 },
        { id: 'rinter', label: 'Rewarded Rich Media', count: 0 },
        { id: 'inter', label: 'Interstitial', count: 0 }
      ]
      this.allAdTypesValue = adTypes
    }
    if (this.allImpTypesValue.length === 0) {
      const impTypes = [
        { id: 'display',          label: 'Display' }, 
        { id: 'ibv',              label: 'In Banner Video' },
        { id: 'native',           label: 'Native' },
        { id: 'rewarded_display', label: 'Rewarded Display' },
        { id: 'rewarded_video',   label: 'Rewarded Video' },
        { id: 'video',            label: 'Video' }
      ]
      this.allImpTypesValue = impTypes
    }

    this.availableAdTypesValue = this.allAdTypesValue
    this.availableImpTypesValue = this.allImpTypesValue
    this.filteredAdTypesValue = this.allAdTypesValue

    this.updateFilterSelects()
  },

  onFilterChange() {
    this.currentPageValue = 0
    this.loadLineSuggestions('Filtering...')
  }
}
